import { convertIdentifier } from 'intl-codegen/runtime';
import React from 'react';

const warned = {};
function warnOnce(msg) {
    if (warned[msg]) {
        return;
    }
    console.warn(msg);
    warned[msg] = true;
}
function createReactAPI() {
    const Context = React.createContext(undefined);
    const { Provider, Consumer } = Context;
    // @ts-ignore: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20544
    return { Context, Provider, Consumer, Localized, useIntl };
    function useIntl() {
        const intl = React.useContext(Context);
        if (!intl) {
            throw new Error("Localization not initialized correctly.\nMake sure to include `<Provider value={intl}>` in your component tree.");
        }
        return intl;
    }
    function Localized({ id = "", params = {} }) {
        let intl;
        try {
            intl = useIntl();
        }
        catch (error) {
            warnOnce(error.message);
            return id;
        }
        const fn = intl[convertIdentifier(id)];
        if (fn) {
            const result = fn(params);
            if (typeof result === "string") {
                return result;
            }
            return React.createElement(React.Fragment, undefined, ...result);
        }
        warnOnce(`The translation key "${id}" is not defined.`);
        return id;
    }
}

export { createReactAPI };
